import React from 'react';

export const BuiltWithLogo: React.FC<React.SVGProps<SVGSVGElement>> = (
  props
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 64 64"
    fill="none"
    {...props}
  >
    <rect width="64" height="64" rx="10" fill="#1B4FD8" />
    <rect x="12" y="14" width="40" height="8" rx="2" fill="white" />
    <rect x="12" y="28" width="30" height="8" rx="2" fill="#93C5FD" />
    <rect x="12" y="42" width="20" height="8" rx="2" fill="#BFDBFE" />
  </svg>
);
